module.exports = __webpack_public_path__ + "media/images/area/feature/chubu/02-55407bb7056ca4ef07b9ffbd45a9834c.jpg";